import { render, staticRenderFns } from "./OpportunityList.vue?vue&type=template&id=4b571d1a"
import script from "./OpportunityList.vue?vue&type=script&lang=js"
export * from "./OpportunityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b571d1a')) {
      api.createRecord('4b571d1a', component.options)
    } else {
      api.reload('4b571d1a', component.options)
    }
    module.hot.accept("./OpportunityList.vue?vue&type=template&id=4b571d1a", function () {
      api.rerender('4b571d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/OpportunityList.vue"
export default component.exports